import BuyCourse from './BuyCourse';

export default BuyCourse;
